export default function(listener: EventListenerOrEventListenerObject) {
    document.addEventListener('visibilitychange', listener);
}
